import React from 'react'
import { connect } from 'react-redux'

import styled from '../../theme/styled'
import { Store } from '../../reducers/index'
import {
  getProjectName,
  getProjectDirty,
  getProjectId,
  getIsNewProject,
  getEditableCases,
  getActiveCase,
  EditableCase
} from '../../reducers/project'
import { Link } from 'react-router-dom'

const DisplayWrapper = styled.div`
  font-size: ${({ theme }) => theme.fonts.defaultSize};
  flex: 1 1 auto;
  margin-right: 300px;
`

const CenteredProjectInfo = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.colors.invert};

  strong {
    font-weight: bold;
  }
`

type DisplayProps = {
  cases: EditableCase[]
  activeCase: EditableCase | undefined
  currentProject: string
  dirty: boolean
  projectId: string | undefined
  isNewProject: boolean
}

const CurrentProjectDisplay: React.SFC<DisplayProps> = props => (
  <DisplayWrapper>
    <CenteredProjectInfo>
      <strong>
        {props.isNewProject && 'New project '}
        {props.currentProject}
      </strong>
      {props.dirty && '*'}
      :&nbsp;
      {props.activeCase ? props.activeCase.name : ''}
      {props.cases.length && ` (of ${props.cases.length} cases)`}{' '}
      {props.projectId &&
        props.projectId !== 'new' && (
          <Link to={`/project/${props.projectId}/details`}>edit</Link>
        )}
    </CenteredProjectInfo>
  </DisplayWrapper>
)

const mapStateToProps = (state: Store.Complete) => ({
  cases: getEditableCases(state),
  activeCase: getActiveCase(state),
  currentProject: getProjectName(state),
  isNewProject: getIsNewProject(state),
  dirty: getProjectDirty(state),
  projectId: getProjectId(state)
})

export default connect(mapStateToProps)(CurrentProjectDisplay)



// WEBPACK FOOTER //
// ./src/Components/Layout/CurrentProjectDisplay.tsx